import { render } from "./index.vue?vue&type=template&id=6fc0e678&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6fc0e678&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc0e678"],['__file',"src/views/Legalize/Formulario/AConcluir/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fc0e678"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fc0e678', __exports__)) {
    console.log('reload')
    api.reload('6fc0e678', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6fc0e678&scoped=true", () => {
    console.log('re-render')
    api.rerender('6fc0e678', render)
  })

}


export default __exports__